import Image from "next/image";
import Link from "next/link";
import Typewriter from "../../components/typewriter/typewriter";
import Logo from "./../../public/images/ico-logo/black.png";
import WhiteLogo from "./../../public/images/ico-logo/white.png";
import TypingText from "../../components/typewriter/typewriter";
const hero_11 = () => {
  const heroContent = {
    subTitle: "Build your impact portfolio",
    title: <>Raise funds for impact</>,
    btnText: " Start Earning",
    heroImg: "/images/hero/hero_crypto_trading.png",
    link: "#",
  };
  return (
    <>
      {/* <!-- Hero --> */}
      <section
        className="relative py-24 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: "url('/images/gradient.jpg')",
        }}
      >
        {/* Dark mode background */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat dark:opacity-100 opacity-0 transition-opacity duration-300"
          style={{
            backgroundImage: "url('/images/gradient_dark.jpg')",
          }}
        ></div>

        <div className="container relative z-10">
          <div>
            <div className="dark:hidden">
              <Image
                src={WhiteLogo}
                height="auto"
                width={260}
                className="mx-auto flex top-0 z-10 rounded-md animate-spin-faux3d"
                alt="Impactoverse | Art For Impact"
              />
            </div>
            <div className="hidden dark:block">
              <Image
                src={WhiteLogo}
                height="auto"
                width={260}
                className="mx-auto flex top-0 z-10 rounded-md animate-spin-faux3d"
                alt="Impactoverse | Art For Impact"
              />
            </div>

            <h1 className="font-display text-5xl text-jacarta-700 dark:text-white lg:text-6xl xl:text-7xl text-center">
              {heroContent.title}
            </h1>

            <TypingText />

            <h3 className="mb-2 block font-display text-xl font-medium group-hover:text-accent dark:text-white transition-colors text-center">
              {heroContent.subTitle}
            </h3>
          </div>
        </div>
      </section>

      {/* <!-- end hero -->  */}
    </>
  );
};

export default hero_11;
